import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { TermsAndConditionsModel } from './models/terms-and-conditions.model';

export interface TermsAndConditionsState extends EntityState<TermsAndConditionsModel, TermsAndConditionsModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'termsAndConditions', idKey: 'storeID' })
export class TermsAndConditionsStore extends EntityStore<TermsAndConditionsState, TermsAndConditionsModel> {
  constructor() {
    super();
  }

  akitaPreAddEntity(x: Readonly<TermsAndConditionsModel>): TermsAndConditionsModel {
    return {
      ...x,
      storeID: [x.Type, x.Id, x.LCID].join('-'),
    };
  }
}
